import type { Dispatch, ThunkAction } from '../../../../../types/redux';
import type { EditorAPI } from '#packages/editorAPI';
import { undoRedoHoverPopupClickSrc38Evid1618 } from '@wix/bi-logger-editor-data/v2';
import { biLogger } from '#packages/util';
import {
  onViewSiteHistoryClick,
  reportTopBarViewSiteHistoryClick,
} from '../../../util/siteHistory/siteHistory';

const getEditorAPI: ThunkAction<EditorAPI> = (
  dispatch,
  getState,
  { editorAPI },
) => editorAPI;

export interface UndoTooltipMapDispatchToProps {
  onTooltipCtaClick: () => void;
}

export const handleOnTooltipCtaClick = (editorAPI: EditorAPI) => {
  onViewSiteHistoryClick(editorAPI);

  biLogger.report(
    undoRedoHoverPopupClickSrc38Evid1618({
      navbar_menu_name: 'Undo',
      disabled_state: true,
    }),
  );

  reportTopBarViewSiteHistoryClick();
};

export const mapDispatchToProps = (dispatch: Dispatch) => {
  const editorAPI = dispatch(getEditorAPI);

  return {
    onTooltipCtaClick: () => handleOnTooltipCtaClick(editorAPI),
  };
};
